import type { WorkspaceRoutes } from '@immo/api-contract';
import type { PermissionSource } from '@/lib/permissions/route-gate';

/** The HLRE area's pages in priority order: the area opens on the first one the caller may open. */
export const HLRE_AREA_PAGES: ReadonlyArray<{
  readonly to: (routes: WorkspaceRoutes) => string;
  readonly gate: PermissionSource;
}> = [];
